import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface Question {
  question: string;
  answer: string;
}

interface PeopleAlsoAskProps {
  questions: Question[];
}

export function PeopleAlsoAsk({ questions }: PeopleAlsoAskProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-seo-card/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Otras preguntas frecuentes
          </h2>
          <div className="space-y-4">
            {questions.map((item, index) => (
              <div
                key={index}
                className="bg-seo-dark/50 border border-seo-blue/20 rounded-lg overflow-hidden hover:border-seo-bright/40 transition-all duration-300"
              >
                <button
                  onClick={() => toggleQuestion(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-seo-blue/5 transition-colors"
                >
                  <h3 className="text-lg font-semibold text-white pr-4">
                    {item.question}
                  </h3>
                  {openIndex === index ? (
                    <ChevronUp className="h-5 w-5 text-seo-bright flex-shrink-0" />
                  ) : (
                    <ChevronDown className="h-5 w-5 text-seo-bright flex-shrink-0" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 py-4 bg-seo-card/20 border-t border-seo-blue/10 animate-in slide-in-from-top duration-200">
                    <p className="text-gray-300 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
